<template>
    <div class="app flex-row align-items-sm-center login-container-xs">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-body login-container">
                                <form @submit.prevent.stop="attemptLogin" v-debounce="'attemptLogin'" ref="form" class="mt-4 mt-md-2">
                                    <form-group class="mb-2" :field-parent-classes="'col-12'">
                                        <label slot="label" for="username" class="col-12 col-form-label">{{ trans('contacts.attributes.email_address') }} / {{ trans('contacts.attributes.user_name') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-at"></i></span>
                                            <input id="username" type="text" class="form-control" ref="focus" v-model="username" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <form-group :field-parent-classes="'col-12'">
                                        <label slot="label" for="password" class="col-12 col-form-label">{{ trans('auth.password') }}</label>
                                        <div slot="field" class="input-group">
                                            <span class="input-group-addon"><i class="fa fa-fw fa-lock"></i></span>
                                            <input type="password" id="password" class="form-control" v-model="password" autocomplete="off">
                                        </div>
                                    </form-group>
                                    <div class="form-group row has-danger" v-if="hasErrorMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedErrorMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row has-danger" v-if="hasValidationMessages">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedValidationMessage"></div>
                                        </div>
                                    </div>
                                    <div class="form-group row" v-if="hasWarningMessage">
                                        <div class="col-12">
                                            <div class="form-control-feedback" v-html="formattedWarningMessage"></div>
                                        </div>
                                    </div>
                                    <spinner v-if="state.loadingRedirect" slot="field"></spinner>
                                    <div class="login-button-row">
                                        <button type="submit" class="btn btn-block btn-primary px-4">{{ trans('auth.log_in') }}</button>
                                    </div>
                                    <div v-if="passwordResetEnabled === 1" class="mt-1">
                                        <a class="btn btn-block btn-link px-4" href="#" @click.prevent="goToPasswordReset">
                                            {{ trans('auth.password_forgotten') }}
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex';
    import AuthenticationController from '@/services/Auth/AuthenticationController';
    import LoginController from '@/services/Auth/LoginController';

    import Spinner from '@/components/Loaders/Spinner';
    import FormGroup from '@/components/Forms/FormGroupHorizontal';

    export default {

        name: 'auth-login',

        components: {Spinner, FormGroup},

        data() {
            return {
                username: null,
                password: null,
                failedAttempts: 0,
                passwordResetEnabled: null,
                adminContactEmail: null,
                state: {
                    loadingRedirect: false
                }
            };
        },

        mounted() {
            LoginController.authCheck().then(response => {
                if (response) {
                    // TODO use formSubmitShowWait?
                    this.state.loadingRedirect = true;
                    this.$route.query.from
                        ? this.$router.push({path: this.$route.query.from})
                        : this.$router.push({name: 'dashboard.index'});
                } else {
                    LoginController.getSystemSettingPasswordReset().then(response => {
                        this.passwordResetEnabled = response.enabled;
                        this.adminContactEmail = response.adminContactEmail;
                    });
                }
            });

            this.setPageTitle(this.trans('auth.login'));

            // set focus to Name field
            // behavior might differ depending on browser
            this.$nextTick(() => {
                this.$refs.focus.focus();
            });
        },

        computed: {

            ...mapState(['messages']),

            hasValidationMessages() {
                return Object.keys(this.messages.validation).length > 0;
            },
            formattedValidationMessage() {
                return Object.keys(this.messages.validation).reduce((acc, field) => {
                    return `${acc}${acc ? '<br>' : ''}${this.messages.validation[field]}`;
                }, '');
            },

            hasErrorMessages() {
                return this.messages.error.length > 0;
            },
            formattedErrorMessage() {
                return this.messages.error[0];
            },

            hasWarningMessage() {
                return this.messages.warning !== '';
            },
            formattedWarningMessage() {
                return this.messages.warning;
            }

        },

        methods: {

            ...mapActions(['resetMessages', 'swalToast', 'loadAuthUser', 'loadSidebarLogoUrl']),

            attemptLogin() {
                this.documentShowWait();

                this.resetMessages();

                const self = this;

                AuthenticationController.login(this.username, this.password).then(() => {
                    self.loadAuthUser().then(() => {
                        if (this.$route.query.from) {
                            // Add all query params found to url except "from"
                            const params = Object.assign({}, this.$route.query);

                            delete params.from;

                            this.$router.push({
                                path: this.$route.query.from,
                                query: params
                            });
                        } else {
                            this.$router.push({name: 'dashboard.index'});
                        }
                    }, () => {
                        self.handleAuthFail();
                    }).finally(() => {
                        this.documentHideWait();
                    });
                }, () => {
                    self.handleAuthFail();
                    this.documentHideWait();
                });
            },

            goToPasswordReset() {
                this.$router.push({name: 'password.email'});
            },

            handleAuthFail() {
                this.failedAttempts++;
                this.swalToast({type: 'error', message: [this.trans('exceptions.login_failed')]});
                if (this.passwordResetEnabled !== 1) {
                    this.swalToast({
                        type: 'warning',
                        message: this.adminContactEmail
                            ? this.trans('auth.please_contact_email', {email: this.adminContactEmail})
                            : this.trans('auth.please_contact_admin')
                    });
                }
            }

        }

    };

</script>



// WEBPACK FOOTER //
// src/views/Auth/Login.vue